import { UserRole } from "@fitness-app/data-models";

import { usePostHogFeatureFlag } from "~/hooks/usePostHogFeatureFlag";
import { useUserRole } from "~/hooks/trainer/useUserRole";

/** TRE-1761 — kill-switch symulatora działań klientki. */
export const SIMULATOR_FEATURE_FLAG = "trainee-simulator";

/**
 * Ref projektu Supabase stagingu. Bramkujemy po nim, a NIE po `import.meta.env.DEV` ani
 * `NODE_ENV`: liczy się to, do której bazy realnie piszemy, a nie jak zbudowano frontend.
 * Produkcyjny build wskazujący na staging ma działać, a lokalny dev wpięty w proda — nie.
 */
const STAGING_PROJECT_REF = "imqwfnfhoivklhutcolk";

export const isStagingEnvironment = (): boolean =>
  String(import.meta.env.VITE_SUPABASE_PROJECT_URL ?? "").includes(STAGING_PROJECT_REF);

/**
 * Symulator pisze do tych samych tabel co aplikacja klientki, więc jego wpisy są
 * nieodróżnialne od prawdziwych i wchodzą do rankingów. Stąd trzy niezależne bramki:
 * środowisko (tylko staging), flaga PostHog i rola (wyłącznie właściciel konta).
 */
export const useSimulatorAccess = () => {
  const { enabled: flagEnabled, isLoading } = usePostHogFeatureFlag(SIMULATOR_FEATURE_FLAG);
  const { role } = useUserRole();

  const isStaging = isStagingEnvironment();
  const isOwner = role === UserRole.TRAINER;

  return {
    canUseSimulator: isStaging && isOwner && flagEnabled,
    isStaging,
    isOwner,
    isLoading,
  };
};
